import React from "react";
import Header from "../components/layout/Header";
import { Sidebar } from "../components/layout/Sidebar";
import { PageWrapper } from "../components/layout/PageWrapper";
import { TopBar } from "../components/common/TopBar";
import CompanyListTable from "../components/company/CompanyListTable";
import { useThemeToggle } from "../hooks/useThemeToggle";


export default function AdminCompanyList() {
useThemeToggle();
return (
<div className="main-wrapper">
<Header />
<Sidebar />
<PageWrapper>
<TopBar active="grid" />
{/* Inline style block from original retained exactly where needed */}
<style>{`.social-links{display:flex;gap:10px;align-items:center}.social-links a{margin-right:10px;text-decoration:none}`}</style>
<div className="row">
<div className="col-sm-12">
<div className="card-table card p-2">
<div className="card-table card p-2">
<div className="card-body">
<CompanyListTable />
</div>
</div>
</div>
</div>
</div>
</PageWrapper>
</div>
);
}